import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: "MENUITEMS.MENU.TEXT",
    isTitle: true,
  },
  {
    id: 2,
    label: "MENUITEMS.DEVICES.TEXT",
    icon: "bx-chip",
    link: "/eu_dev_list",
  },
  {
    id: 2,
    label: "MENUITEMS.USERS.TEXT",
    icon: "bx-user",
    link: "/su_user_list",
  },
  {
    id: 2,
    label: "MENUITEMS.FIRMWARE_UPDATES.TEXT",
    icon: "bx-cloud-upload",
    link: "/su_fw_manager",
  }, {
    id: 2,
    label: "MENUITEMS.DEALER_LOCATION.TEXT",
    icon: "bx-world",
    link: "/su_dealer_location",
  },
  
];
